import { createRouter, createWebHistory } from "vue-router";

// Login page
import LoginView from "../views/LoginView";

//==========================Admin=============================//
import AdminView from "@/views/AdminView";

//=======================Admin Profile=======================//
import AdminProfile from "@/views/AdminPages/AdminProfile";

//=======================Admin Routes=======================//
// Dashboard
import AdminDashboard from "@/views/AdminPages/AdminDashboard";

// Categories
import AdminCategories from "@/views/AdminPages/AdminCategories";

// Contact Us
import AdminContactUs from "@/views/AdminPages/AdminContactUs";

// Codes
import AdminCodes from "@/views/AdminPages/AdminCodes";

//=======================Teaching aids Routes=======================//
// Lessons Routes
import AdminLessons from "@/views/AdminPages/AdminLessons/AdminLessons";
import AddLesson from "@/views/AdminPages/AdminLessons/LessonsSubPages/AddLesson";
import AddLessonEditVideo from "@/views/AdminPages/AdminLessons/LessonsSubPages/AddLessonEditVideo";
import AddLessonEditExam from "@/views/AdminPages/AdminLessons/LessonsSubPages/AddLessonEditExam";
import AddExam from "@/views/AdminPages/AdminLessons/LessonsSubPages/AddExam";
import AddVideo from "@/views/AdminPages/AdminLessons/LessonsSubPages/AddVideo";
import LessonView from "@/views/AdminPages/AdminLessons/LessonsSubPages/LessonView";
import ViewVideo from "@/views/AdminPages/AdminLessons/LessonsSubPages/ViewVideo"; // view video screen
import VideoComments from "@/views/AdminPages/AdminLessons/LessonsSubPages/VideoComments"; // view video screen
import LessonEdit from "@/views/AdminPages/AdminLessons/LessonsSubPages/LessonEdit";
import LessonEditExam from "@/views/AdminPages/AdminLessons/LessonsSubPages/EditExam";
import LessonEditVideo from "@/views/AdminPages/AdminLessons/LessonsSubPages/EditVideo";

// Exams Routes
import AdminExams from "@/views/AdminPages/AdminExam/AdminExams";
import AdminExamsAdd from "@/views/AdminPages/AdminExam/ExamsSubPages/AdminExamsAdd";
import AdminExamsView from "@/views/AdminPages/AdminExam/ExamsSubPages/AdminExamsView";
import AdminExamsEdit from "@/views/AdminPages/AdminExam/ExamsSubPages/AdminExamsEdit";
import AdminExamStudents from "@/views/AdminPages/AdminExam/ExamsSubPages/AdminExamStudents";
import AdminExamGradeStudent from "@/views/AdminPages/AdminExam/ExamsSubPages/AdminExamGradeStudent";

// Reviews Routes
import AdminReviews from "@/views/AdminPages/AdminReviews";

// Infographics Routes
import AdminImages from "@/views/AdminPages/AdminImages";
//===========================Posting=============================//
// Post Routes
import AdminPosts from "@/views/AdminPages/AdminPost/AdminPosts";
import addPost from "@/views/AdminPages/AdminPost/PostsSubPages/AdminAddPost";
import editPost from "@/views/AdminPages/AdminPost/PostsSubPages/AdminEditPost";
import viewPost from "@/views/AdminPages/AdminPost/PostsSubPages/AdminViewPost";

// Informations Routes
import AdminInformations from "@/views/AdminPages/AdminInformations/AdminInformations";
import addInformation from "@/views/AdminPages/AdminInformations/InformationsSubPages/AdminAddInformation";
import editInformation from "@/views/AdminPages/AdminInformations/InformationsSubPages/AdminEditInformation";
import viewInformation from "@/views/AdminPages/AdminInformations/InformationsSubPages/AdminViewInformation";

//===========================Banners=============================//
import AdminBanners from "@/views/AdminPages/AdminBanners/AdminBanners";
import addBanner from "@/views/AdminPages/AdminBanners/BannersSubPages/AdminAddBanner";
import editBanner from "@/views/AdminPages/AdminBanners/BannersSubPages/AdminEditBanner";
import viewBanner from "@/views/AdminPages/AdminBanners/BannersSubPages/AdminViewBanner";

//===========================Classes=============================//
import AdminClasses from "@/views/AdminPages/AdminClasses/AdminClasses";
import StudentsOfClass from "@/views/AdminPages/AdminClasses/ClassesSubPages/StudentsOfClass";

//===========================Groups=============================//
import AdminGroups from "@/views/AdminPages/AdminGroups/AdminGroups";
import GroupDetails from "@/views/AdminPages/AdminGroups/GroupsSubPages/GroupDetails";

//===========================Students=============================//
import AdminStudents from "@/views/AdminPages/AdminStudents/AdminStudents";
import StudentContent from "@/views/AdminPages/AdminStudents/StudentsSubPages/StudentContent";

//===========================Users=============================//
import AdminUsers from "@/views/AdminPages/AdminUsers";

//===========================Offers=============================//
import AdminOffers from "@/views/AdminPages/AdminOffers";

//===========================Admins=============================//
import Admins from "@/views/AdminPages/Admins";

//===============================================================//
import PageNotFound from "@/views/NotFound";
import Swal from "sweetalert2";
import { sanitizePermissions } from "@/constants/permissions";

// Firebase Auth
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase/init";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
    beforeEnter: (to, from, next) => {
      getCurrentUser().then((user) => {
        if (user) {
          next("/admin/dashboard");
        } else {
          next();
        }
      });
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminView,
    redirect: "/admin/dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      //=======================Admin Profile=======================//
      {
        path: "profile",
        name: "profile",
        component: AdminProfile,
      },

      //=======================Dashboard=======================//
      {
        path: "dashboard",
        name: "dashboard",
        component: AdminDashboard,
        meta: {
          permission: "dashboard",
        },
      },
      // ========================= VIDEOS =============================//
      {
        path: "videos/:video_id",
        name: "videos",
        component: ViewVideo,
        props: true,
        meta: {
          permission: "lessons",

        },
      },
      {
        path: "videos/:video_id/comments/:comment_id",
        name: "video_comment",
        component: VideoComments,
        meta: {
          permission: "video_comments",
        },
      },
      //=======================Categories=======================//
      {
        path: "categories",
        name: "categories",
        component: AdminCategories,
        meta: {
          permission: "categories",
        },
      },
      //=======================Lessons=======================//
      {
        path: "lessons",
        name: "lessons",
        component: AdminLessons,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/lesson_details",
        name: "lesson_details",
        component: AddLesson,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/add_exam",
        name: "add_lesson_exam",
        component: AddExam,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "lessons/add_Video",
        name: "add_Video",
        component: AddVideo,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/Edit_Select_Video/:index",
        name: "Edit_Select_Video",
        component: AddVideo,
        props: true,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/AddLesson/EditVideo/:index",
        name: "AddLessonEditVideo",
        component: AddLessonEditVideo,
        props: true,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/AddLesson/EditExam/:index",
        name: "AddLessonEditExam",
        component: AddLessonEditExam,
        props: true,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "lessons/view_lesson/:index",
        name: "view_lesson",
        component: LessonView,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/view_lesson/:index/:video_id",
        name: "view_video",
        component: ViewVideo,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/view_lesson/:index/:video_id/comments/:comment_id",
        name: "video_comment",
        component: VideoComments,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/edit_lesson/:id",
        name: "edit_lesson",
        component: LessonEdit,
        meta: {
          permission: "lessons",
        },
      },
      {
        path: "lessons/edit_lesson/edit_exam/:id",
        name: "lesson_edit_exam",
        component: LessonEditExam,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "lessons/edit_lesson/edit_video/:id",
        name: "lesson_edit_video",
        component: LessonEditVideo,
        meta: {
          permission: "lessons",

        },
      },
      //=======================Exams=======================//
      {
        path: "exams",
        name: "exams",
        component: AdminExams,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "exams/add_exam",
        name: "examsadd_exam",
        component: AdminExamsAdd,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "exams/view_exam/:id",
        name: "view_exam",
        component: AdminExamsView,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "exams/edit_exam/:id",
        name: "edit_exam",
        component: AdminExamsEdit,
        meta: {
          permission: "exams",
        },
      },
      {
        path: "exams/students/:id",
        name: "exam_students",
        component: AdminExamStudents,
        meta: {
          permission: "exams",
        },
      },
      {
        // Manual grading of a student's essay answers.
        path: "exams/students/:id/grade/:studentId",
        name: "exam_grade_student",
        component: AdminExamGradeStudent,
        meta: {
          permission: "exams",
        },
      },
      //=======================Reviews=======================//
      {
        path: "reviews",
        name: "reviews",
        component: AdminReviews,
        meta: {
          permission: "reviews",
        },
      },
      //=======================Infographics=======================//
      {
        path: "images",
        name: "images",
        component: AdminImages,
        meta: {
          permission: "images",
        },
      },
      //=======================Codes=======================//
      {
        path: "/codes",
        name: "codes",
        component: AdminCodes,
        meta: {
          permission: "codes",
        },
      },
      //=======================Posts=======================//
      {
        path: "/posts",
        name: "posts",
        component: AdminPosts,
        meta: {
          permission: "posts",
        },
      },
      {
        path: "/posts/add_post",
        name: "add_post",
        component: addPost,
        meta: {
          permission: "posts",
        },
      },
      {
        path: "/posts/view_post/:id",
        name: "view_post",
        component: viewPost,
        meta: {
          permission: "posts",
        },
      },
      {
        path: "/posts/edit_post/:id",
        name: "edit_post",
        component: editPost,
        meta: {
          permission: "posts",
        },
      },
      //=======================Informations=======================//
      {
        path: "/informations",
        name: "informations",
        component: AdminInformations,
        meta: {
          permission: "informations",
        },
      },
      {
        path: "/informations/add_information",
        name: "add_information",
        component: addInformation,
        meta: {
          permission: "informations",
        },
      },
      {
        path: "/informations/view_information/:id",
        name: "view_information",
        component: viewInformation,
        meta: {
          permission: "informations",
        },
      },
      {
        path: "/informations/edit_information/:id",
        name: "edit_information",
        component: editInformation,
        meta: {
          permission: "informations",
        },
      },
      //=======================Banners=======================//
      {
        path: "/banners",
        name: "banners",
        component: AdminBanners,
        meta: {
          permission: "banners",
        },
      },
      {
        path: "/banners/add_banner",
        name: "add_banner",
        component: addBanner,
        meta: {
          permission: "banners",
        },
      },
      {
        path: "/banners/view_banner/:id",
        name: "view_banner",
        component: viewBanner,
        meta: {
          permission: "banners",
        },
      },
      {
        path: "/banners/edit_banner/:id",
        name: "edit_banner",
        component: editBanner,
        meta: {
          permission: "banners",
        },
      },
      //=======================Classes=======================//
      {
        path: "/classes",
        name: "classes",
        component: AdminClasses,
        meta: {
          permission: "classes",
        },
      },
      {
        path: "/class/students/:id",
        name: "StudentsOfClass",
        component: StudentsOfClass,
        meta: {
          permission: "classes",
        },
      },
      //=======================Groups=======================//
      {
        path: "/groups",
        name: "groups",
        component: AdminGroups,
        meta: {
          permission: "groups",
        },
      },
      {
        path: "/groups/:id",
        name: "groupDetails",
        component: GroupDetails,
        meta: {
          permission: "groups",
        },
      },
      //=======================Students=======================//
      {
        path: "/students",
        name: "students",
        component: AdminStudents,
        meta: {
          permission: "students",
        },
      },
      {
        path: "/students/:index",
        name: "studentContent",
        component: StudentContent,
        meta: {
          permission: "students",
        },
      },
      //=======================Users=======================//
      {
        path: "/users",
        name: "users",
        component: AdminUsers,
        meta: {
          permission: "users",
        },
      },
      //=======================Offers=======================//
      {
        path: "/offers",
        name: "offers",
        component: AdminOffers,
        meta: {
          permission: "offers",
        },
      },
      {
        path: "/admins",
        name: "admins",
        component: Admins,
        meta: {
          permission: "admins",
        },
      },
      //=======================Contact Us=======================//
      {
        path: "/contact-us",
        name: "contact-us",
        component: AdminContactUs,
        meta: {
          permission: "contact",
        },
      },
    ],
  },
  { path: "/:pathMatch(.*)*", component: PageNotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    );
  });
};

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const user = await getCurrentUser();
    if (user) {
      const userDocument = await getDoc(doc(db, "Admins", user.uid));
      const userData = userDocument.data();
      const permission = to.meta?.permission;
      // Drop keys no route gates on, so a stale array cannot grant access.
      const permissions = sanitizePermissions(userData?.permissions);

      if (!permission) return next();
      if (!permissions.includes(permission)) {
        const Toast = Swal.mixin({
          toast: false,
          position: "center",
          showConfirmButton: true,
          //  timer: 2000,
          //  timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "هناك صلاحيات مفقوده!",
          text: "ليس لديك صلاحية للوصول لتلك الصفحة للاتمام الاجراءات المطلوبه , يمكنك التواصل مع المدير المسؤول ليتم اتخاذ تلك الاجراء بدلا منك.",
        });
        return next({ name: "profile" });
      }

      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
